import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OrganizationSubscription } from './models/organization-subscription.model';
import { ExternalLink } from './models/external-link.model';

export type OrganizationSubscriptionPortalLinkType = 'payment' | 'plan' | 'cancel';

@Injectable({
  providedIn: 'root',
})
export class OrganizationSubscriptionService {
  private BASE_URL = `${environment.apiOrg.url}/organization/subscription`;

  constructor(private http: HttpClient) {}

  public getSubscription(): Observable<OrganizationSubscription> {
    return this.http.get<OrganizationSubscription>(this.BASE_URL);
  }

  public generatePortalLink(
    linkType: OrganizationSubscriptionPortalLinkType,
  ): Observable<ExternalLink> {
    return this.http.post<ExternalLink>(`${this.BASE_URL}/external-links/portal`, {
      type: linkType,
    });
  }

  public generatePortalPromoLink(couponId: string, priceId: string): Observable<ExternalLink> {
    return this.http.post<ExternalLink>(`${this.BASE_URL}/external-links/portal`, {
      type: 'promo',
      couponId,
      priceId,
    });
  }
}
